import { Box, BoxProps, LoadingWheel, Text } from "@vinomofo/components";
import { useEffect, useState } from "react";

import { AddCouponForm } from "../summary/AddCouponForm";
import { PercentageIcon } from "@vinomofo/icons";
import { SummaryLine } from "../summary/SummaryLine";
import config from "../../../config.json";
import { currencyFormatter } from "../../utils/currency-formatter";
import styled from "styled-components";
import useAuth from "../../hooks/use-auth";
import { useCart } from "../../hooks/use-cart";
import { useCartDiscount } from "../../hooks/cart/use-cart-discount";
import { useStaffDiscount } from "../../hooks/cart/use-staff-discount";

const FadingDiscountWrapper = styled(Box)`
  transition: opacity 0.1s linear;
`;

interface ICartPromotion extends BoxProps {
  inMiniCart?: boolean;
}

export const CartPromotions = ({
  inMiniCart = false,
  ...props
}: ICartPromotion): JSX.Element => {
  const { cart, isLoading: isCartLoading } = useCart();
  const { user } = useAuth();
  const { isGiftCardOnly, totalDiscountAmount } = cart;
  const [cartTotalDiscount, setCartTotalDiscount] = useState(0);

  const {
    totalCartDiscount,
    fetchTotalCartDiscount,
    isLoading: isDiscountLoading,
  } = useCartDiscount(cart);

  const {
    totalStaffDiscount,
    fetchTotalStaffDiscount,
    isLoading: isStaffDiscountLoading,
  } = useStaffDiscount(cart);

  useEffect(() => {
    if (cart) {
      fetchTotalCartDiscount(cart.lineItems);
      if (user) fetchTotalStaffDiscount(cart.lineItems);

      setCartTotalDiscount(
        totalDiscountAmount +
          (user &&
          user.customer_group &&
          user.customer_group.name === config.STAFF_GROUP_NAME
            ? totalStaffDiscount || 0
            : 0)
      );
    }
  }, [cart?.lineItems, totalStaffDiscount]);

  // if (totalCartDiscount === 0) {
  //   return null;
  // }

  return (
    <>
      {user &&
        user.customer_group &&
        user.customer_group.name === config.STAFF_GROUP_NAME &&
        totalStaffDiscount !== 0 && (
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            padding={3}
            paddingTop={0}
            {...props}
          >
            <Box>
              <Text fontSize={1} color="heading">
                Discount
              </Text>
              <Text fontSize={0} fontWeight={400}>
                Because you&apos;re staff
              </Text>
            </Box>
            {isStaffDiscountLoading || isDiscountLoading || isCartLoading ? (
              <LoadingWheel borderWidth="5px" size="2em" />
            ) : (
              <Text fontSize={1} color="text.default" fontWeight={500}>
                {totalStaffDiscount > 0
                  ? `-${currencyFormatter(totalStaffDiscount)}`
                  : currencyFormatter(totalStaffDiscount)}
              </Text>
            )}
          </Box>
        )}

      {!inMiniCart && <AddCouponForm />}

      {/* Total Discount */}
      {cartTotalDiscount > 0 && (
        <SummaryLine
          label="Total Discount"
          amount={-cartTotalDiscount}
          loading={isCartLoading}
          xlLabel
          {...props}
        />
      )}

      {!isGiftCardOnly && totalCartDiscount > 0 && (
        <Box
          width="100%"
          justifyContent="center"
          backgroundColor="smurfette"
          padding={3}
          display="flex"
          borderColor="white"
          {...props}
        >
          <FadingDiscountWrapper
            opacity={isDiscountLoading || isCartLoading ? 0 : 1}
            display="flex"
          >
            <Box color="papaSmurf" width="1em" height="1em" mr={2} mt="3px">
              <PercentageIcon />
            </Box>
            <Text fontSize="14px" color="heading">
              You’re saving{" "}
              <Text as="span" fontWeight={500} fontSize="14px" color="mystique">
                {currencyFormatter(totalCartDiscount)}
              </Text>{" "}
              off RRP on this order
            </Text>
          </FadingDiscountWrapper>
        </Box>
      )}
    </>
  );
};
